// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__tj9VY","modalFooterButton":"ModalNotes_modalFooterButton__1Tnb4"};